import React from 'react';
import { Box } from '@styleseat/ui';
import { Pressable } from 'react-native';
import { MobileSearchProps } from './types';
import { Absolute, AnimatedBadge } from '../../ui';
import { BasicSearchIcon } from '../../ui/Icons';

export const MobileSearch = ({
  showMobileSearch,
  showMobileSearchDot,
  onMobileSearchClick,

}: MobileSearchProps) => {
  if (!showMobileSearch) {
    return null;
  }
  return (
    <Pressable
      onPress={onMobileSearchClick}
      testID="mobile-header-search-icon"
    >
      <Box
        alignItems="center"
        flexDirection="column"
        justifyContent="center"
        paddingRight={4}
      >
        <Absolute
          top={0}
          right={7}
        >
          <AnimatedBadge
            appearance="client"
            show={showMobileSearchDot}
            testID="mobile-header-search-dot"
          />
        </Absolute>
        <Box>
          <BasicSearchIcon />
        </Box>
      </Box>
    </Pressable>
  );
};
